const numberFormat = new Intl.NumberFormat(document.documentElement.lang || undefined)

export const formatNumber = (value) => (value === null || value === undefined ? '—' : numberFormat.format(value))
